import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconWorkFlow = props => (
  <SvgIcon {...props} viewBox="0 0 20 20">
    <path d="m2 4h-2v14c0 1.1 0.9 2 2 2h14v-2h-14v-14zm16-4h-12c-1.1 0-2 0.9-2 2v12c0 1.1 0.9 2 2 2h12c1.1 0 2-0.9 2-2v-12c0-1.1-0.9-2-2-2zm-1 9h-10v-2h10v2zm-4 4h-6v-2h6v2zm4-8h-10v-2h10v2z" />
  </SvgIcon>
);

export default IconWorkFlow;



// WEBPACK FOOTER //
// ./src/components/icons/IconWorkFlow.js